import {
  Maybe,
  ProductCardFeedDataFragment as ProductCardFeedDataFragmentV3,
  ProductDetailsProductsDataFragment,
  ProductMultipleActionStatus,
  ProductVisibleStatus,
} from '@models';
import { Product } from '@components/ProductCard';
import { ProductCardFeedDataFragment as ProductCardFeedDataFragmentV4 } from '@newModels';

// types
export type ProductCardFeedDataFragmentEdge = Maybe<(
  { __typename?: 'FeedEdge'
    node?: Maybe<(
      { __typename?: 'Product' }
      & Pick<Product, 'id'>
      & (ProductCardFeedDataFragmentV3 | ProductCardFeedDataFragmentV4)
    )>
  }
)>;

export const convertProductProps = (
  node: (
    ProductCardFeedDataFragmentV4
    | ProductCardFeedDataFragmentV3
    | ProductDetailsProductsDataFragment
  ) & {
    isProcessingMultipleAction?: ProductMultipleActionStatus,
    promotion?: FeedProductPromotion | null,
  },
): Product => {
  let size;
  if ('size' in node) {
    size = node.size;
  } else if ('sizes' in node) {
    size = node.sizes;
  }

  let hasRecentActivity: boolean;
  if ('ownerHasRecentActivity' in node) {
    hasRecentActivity = node.ownerHasRecentActivity;
  } else {
    hasRecentActivity = node.seller?.hasRecentActivity || true;
  }

  let catalog;
  if ('catalogSlug' in node && node.catalogSlug) {
    catalog = { slug: node.catalogSlug };
  } else if ('catalog' in node && node.catalog) {
    catalog = { slug: node.catalog.slug };
  }

  return {
    ...node,
    id: node.id,
    url: node.url,
    name: node.name,
    thumbnail: node.thumbnail || '',
    likes: node.likes,
    price: node.price,
    size: size || [],
    brand: node.brand,
    catalog,
    saleLabel: node.saleLabel,
    isLiked: node.isLiked || false,
    isNew: node.isNew,
    isReserved: node.statusTitle === ProductVisibleStatus.Reserved,
    isTop: 'isTop' in node ? node.isTop : false,
    isUkrainian: node.isUkrainian,
    oldPrice: node.oldPrice,
    discountPercent: node.discountPercent,
    freeDeliveryServices: 'freeDeliveryServices' in node ? node.freeDeliveryServices || [] : [],
    hasRecentActivity,
    tags: node.tags,
    rating: node.rating,
    ratingAmount: node.ratingAmount,
    seller: node.seller,
    isViewed: 'isViewed' in node ? node.isViewed : undefined,
    createdAt: 'createdAt' in node ? node.createdAt : undefined,
  };
};

/*
 * This function need for convert edges with the `ProductCardFeedDataFragment`
 * type to Product type.
 */
export const edgesToProducts = (
  edges: (ProductCardFeedDataFragmentEdge & {
    isProcessingMultipleAction?: ProductMultipleActionStatus,
    promotion?: FeedProductPromotion,
  } | null)[],
): Product[] => (
  edges
    ?.filter((edge) => edge?.node)
    .map((edge) => convertProductProps(edge!.node!)) || []
);

export const renderProductCards = edgesToProducts;
